<!--
	TEMPLATE
-->
<template>
<div class="editable-input">
	<div :class="{'text-center': isEditView}">
		<a v-if="input" :href="epcUrl" target="_blank">EPC file</a>
		<span v-if="!input">No EPC uploaded</span>
	</div>

	<div v-if="isEditView">
		<s3 v-model="input" extensions=".png, .jpeg, .jpg, .pdf, .PNG, .JPEG, .JPG, .PDF" :single="true" label="Change EPC"></s3>

		<span>Hint: Please submit your EPC graph. If you don't have one you can generate it from <a href="http://epc.rightmove.co.uk/epcgenerator" target="_blank">here</a>.<br></span>
	</div>
</div>
</template>

<!--
	SCRIPT
-->
<script>
import utils from '@/libs/mixins.js';
import vModelNested from '@/libs/vModelNested.js';
import S3 from '../../components/S3.vue';

export default {
	props: {
		value: String,
		options: Object,
		isEditView: Boolean
	},
	data: function() {
		return {
		}
	},
	mixins: [utils],
	components: {
		's3': S3
	},
	computed: {
		input: vModelNested,
		epcUrl: function() {
			if(this.input != null) {
				return this.s3url(this.input);
			} else {
				return this.input;
			}
		}
	},
	methods: {
	}
}
</script>



// WEBPACK FOOTER //
// src/components/editable-items/EditableEPC.vue